import type { BulkTransactionRecord, RecipientRecord } from "@kkp/api-client";

// Demo recipients, typed by the generated Rust wire type `RecipientRecord` (no
// hand-mirrored shape). `phone` is `string | null` on the wire, so demo rows set
// it explicitly to null.
export const RECIPIENTS: RecipientRecord[] = [
  {
    seqId: "001",
    fullName: "Aisha Rahmadani",
    employeeId: "EMP-2024-0198",
    ktpId: "3174120312030001",
    npwpId: "12.345.678.9-012.345",
    bankName: "BCA",
    bankCode: "014",
    bankAccount: "0123456789",
    phone: null,
    totalReceivedCount: "1",
    totalReceivedAmount: "5000000",
    status: "Active",
  },
  {
    seqId: "002",
    fullName: "Rafi Pratama",
    employeeId: "EMP-2023-0042",
    ktpId: "3276442144210002",
    npwpId: "09.876.543.2-109.876",
    bankName: "BRI",
    bankCode: "002",
    bankAccount: "9876543210",
    phone: null,
    totalReceivedCount: "1",
    totalReceivedAmount: "5000000",
    status: "Active",
  },
  {
    seqId: "003",
    fullName: "Nadia Putri",
    employeeId: "EMP-2022-0311",
    ktpId: "3201778977890003",
    npwpId: "21.234.567.8-901.234",
    bankName: "Mandiri",
    bankCode: "008",
    bankAccount: "1400012345678",
    phone: null,
    totalReceivedCount: "1",
    totalReceivedAmount: "5000000",
    status: "Active",
  },
  {
    seqId: "004",
    fullName: "Fajar Hidayat",
    employeeId: "EMP-2024-0110",
    ktpId: "3171305530550004",
    npwpId: "16.789.012.3-456.789",
    bankName: "BNI",
    bankCode: "009",
    bankAccount: "0120012345678",
    phone: null,
    totalReceivedCount: "1",
    totalReceivedAmount: "5000000",
    status: "Active",
  },
  {
    seqId: "005",
    fullName: "Siti Alifah",
    employeeId: "EMP-2023-0265",
    ktpId: "3273990299020005",
    npwpId: "15.678.901.2-345.678",
    bankName: "CIMB",
    bankCode: "022",
    bankAccount: "900123456789",
    phone: null,
    totalReceivedCount: "1",
    totalReceivedAmount: "5000000",
    status: "Active",
  },
];

export const INITIAL_TRANSACTIONS: BulkTransactionRecord[] = [
  {
    seqId: "001",
    bulkTransactionId: "KKP-0001-2601-001",
    createdAt: "2026-01-22 09:15",
    executedAt: "2026-01-22 09:18",
    totalReceivable: "25000000",
    totalToFund: "25025000",
    totalRecipients: "5",
    status: "Executed",
    channel: "Bank",
  },
];

export function formatBankDetails(
  bankName: string,
  bankCode: string,
  bankAccount: string,
): string {
  return `${bankName} (${bankCode}) | ${bankAccount}`;
}
